import React, { useEffect, useState } from "react";
import { object, string } from "prop-types";
import * as style from "./styles.module.scss";

const Results = ({ quizResults, title, name, quizShowResults }) => {
  const { results, retries, status, score } = quizResults;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (name === quizShowResults) {
      setVisible(true);
    }
  }, [quizShowResults]);

  return (
    <div className={`${style.resultsContainer}`}>
      <div
        className={`${style.resultsHeader}`}
        onClick={() => setVisible(!visible)}
      >
        <p>{title} Results</p>

        <img
          src="https://www.hrgo.co.uk/images/nav/nav-arrow-down.svg"
          className={`${visible && style.rotateimg180} ${style.arrowIcon}`}
          width="10px"
          height="10px"
          alt="arrow-down"
        />
      </div>
      {visible && (
        <>
          <table className={`${style.resultsTable}`}>
            <thead>
              <tr>
                <th>Question</th>
                <th>Result</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(results).map(([key, value]) => (
                <tr key={key}>
                  <td>{key}</td>
                  <td>
                    <strong>{value}</strong>
                  </td>
                </tr>
              ))}
              <tr>
                <td>
                  <strong>SCORE</strong>
                </td>
                <td>
                  <strong>{score}</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>STATUS</strong>
                </td>
                <td>
                  <strong>{status}</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>RETRIES LEFT</strong>
                </td>
                <td>
                  <strong>{status === "Pass" ? 0 : retries}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </>
      )}
    </div>
  );
};

Results.propTypes = {
  quizResults: object,
  title: string,
};

export default Results;
